import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

import { renderInstructorPage } from './-route-wrappers';

const QuestionDetails = lazyRouteComponent(() => import('@/_instructor/on-demand-tutoring/question-details'));

export const Route = createFileRoute('/_instructor/on-demand-tutoring/question-details')({
  component: () => renderInstructorPage(QuestionDetails),
});
